<template>
  <div class="nav-header">
    <!-- origin nav -->
    <div class="content" id="navContent">
      <div @click="originNavClick" class="l">
        <img src="@/assets/m/logo.png" alt="" />
        <span>Transformers</span>
        <!-- <div class="title1">{{ $t("navbar.index") }}</div> -->
      </div>
      <!-- 注册开始 -->
      <!-- <div class="signs" v-if="userEmail == null">
        <span @click="login">Sign In</span>
      </div> -->
      <!-- 注册开始 -->
      <!-- 登录账号开始 -->
      <!-- 注册登录模块结束 -->

      <!-- <div class="loginafter" @click="loginafter" v-else>
        <img src="@/assets/pc/Logo/tu.png" />
        <div>{{ userEmail }}</div>
      </div> -->

      <!-- 登录账号结束 -->
      <img class="r" @click="showNav" src="@/assets/m/caidan1.png" alt="" />
    </div>

    <van-popup v-model="shows1">
      <div class="navTag">
        <!-- popup内的nav -->
        <div class="navtitle">
          <div class="l logo" @click="goPage('/m/Index')">
            <img src="@/assets/m/logo.png" />
            <span>Transformers</span>
            <!-- <div class="title1">{{ $t("navbar.index") }}</div> -->
          </div>
          <img
            class="r"
            @click="shows1 = false"
            src="@/assets/m/caidan.png"
            alt=""
          />
        </div>

        <Collapse v-model="activeName" accordion>
          <div class="Ecological" @click="goPage('/m/Index')">
            <!-- <div class="Ecological" @click="goPage('/m/Learning/building')"> -->
            <CollapseItem name="Home">
              <template #title> {{ type === "zh" ? "Home" : "Home" }}</template>
            </CollapseItem>
          </div>

          <CollapseItem name="Blockchain">
            <template #title>
              {{ type === "zh" ? "Blockchain" : "Blockchain" }}</template
            >

            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/BlockList' }"
              @click="goPage('/m/BlockList')"
            >
              <div>Blocks</div>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/TransferList' }"
              @click="goPage('/m/TransferList')"
            >
              <div>Transactions</div>
            </div>
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/ContractsList' }"
              @click="goPage('/m/ContractsList')"
            >
              <div>Contracts</div>
            </div>
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/AccountsList' }"
              @click="goPage('/m/AccountsList')"
            >
              <div>Accounts</div>
            </div> -->
            <!-- 
              <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Indexa' }"
              @click="goPage('/m/Indexa')"
            >
              <div>Indexa</div>
            </div> -->
          </CollapseItem>
          <CollapseItem name="Tokens">
            <template #title>
              {{ type === "zh" ? "Tokens" : "Tokens" }}</template
            >
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/TokensList' }"
              @click="goPage('/m/TokensList')"
            >
              <div>Tokens</div>
            </div> -->
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Toketop' }"
              @click="goPage('/m/Toketop')"
            >
              <div>Top Tokens</div>
            </div>
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/TokensList' }"
              @click="goPage('/m/TokensList')"
            >
              <div>Tokens Transfers</div>
            </div>
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Overaddress' }"
              @click="goPage('/m/Overaddress')"
            >
              <div>Tokens Transfers</div>
            </div> -->
          </CollapseItem>
          <CollapseItem name="NFTs">
            <template #title> {{ type === "zh" ? "NFTs" : "NFTs" }}</template>
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/NftsList' }"
              @click="goPage('/m/NftsList')"
            >
              <div> NFTs</div>
            </div> -->
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Topnfts' }"
              @click="goPage('/m/Topnfts')"
            >
              <div>Top NFTs</div>
            </div>
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/NftsList' }"
              @click="goPage('/m/NftsList')"
            >
              <div>Latest Transfers</div>
            </div>
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/NftOveraddress' }"
              @click="goPage('/m/NftOveraddress')"
            >
              <div>Latest Transfers</div>
            </div> -->
          </CollapseItem>
          <div class="Ecological" @click="goPage('/m/VerifierList')">
            <!-- <div class="Ecological" @click="goPage('/m/Learning/building')"> -->
            <CollapseItem name="Top validators">
              <template #title>
                {{ type === "zh" ? "validators" : "Top validators" }}</template
              >
            </CollapseItem>
          </div>
          <!-- <CollapseItem name="Developers">
            <template #title> {{ type === "zh" ? "Developers" : "Developers" }}</template>
          
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Verify' }"
              @click="goPage('/m/Verify')"
            >
              <div>Verify Contract</div>
            </div>
            <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/Deployment' }"
              @click="goPage('/m/Deployment')"
            >
              <div>Verify Deployment</div>
            </div>
           
          </CollapseItem> -->

          <!-- <div class="Ecological" @click="goPage('/m/charts')">
          
            <CollapseItem name="Top validators">
              <template #title>
                {{ type === "zh" ? "validators" : "Charts" }}</template
              >
            </CollapseItem>
          </div> -->
          <!-- Community -->
        </Collapse>
        <!-- 连接外网模块开始 -->
        <div class="Testnet">
          <div style="display: flex" @click="showTestbox">
            <div class="nettit">Mainnet</div>
            <div class="netselect">
              <img :src="imglogo1" />
            </div>
          </div>
          <div class="testbox" v-show="testflog" @click="hideTestbox">
            <div @click="goPage('/m/Index')"><span style="color: #fff">Mainnet</span></div>

            <!-- <router-link to="/m/index"> -->
            <div >
              <span >Testnet</span>
            </div>
            <!-- </router-link> -->
          </div>
        </div>
        <!-- 连接外网模块结束 -->
      </div>
    </van-popup>
    <Signup
      v-show="flogb"
      :flogb="flogb"
      :floag="floag"
      @signups="signups($event)"
      @loginflog="loginflog($event)"
    ></Signup>
    <Login
      v-show="floag"
      :flogb="flogb"
      :flogc="flogc"
      :floag="floag"
      @loginflog="loginflog($event)"
      @signups="signups($event)"
      @repwd="repwd($event)"
      @emails="emails($event)"
    ></Login>
    <Resignup
      v-show="flogc"
      :flogc="flogc"
      :floag="floag"
      @repwd="repwd($event)"
      @back="back($event)"
    ></Resignup>
    <!-- <Login v-show="floag"></Login> -->
    <!-- <Resignup v-show="floag"></Resignup> -->
  </div>
</template>
<script>
import axios from "axios";
import { getSubStr } from "@/utils/utils";
import { Collapse, CollapseItem } from "vant";
import Signup from "../../views/m/Login/Signup.vue";
import Login from "../../views/m/Login/Login.vue";
import Resignup from "../../views/m/Login/Resignup.vue";
export default {
  components: {
    // Login,
    // CheckUser,
    Signup,
    Login,
    Resignup,
    Collapse,
    CollapseItem,
    // ShowMoney,
  },
  data() {
    return {
      testflog: false,

      imglogo1: require("@/assets/pc/Logo/xia.png"),
      shows1: false,
      shows2: false,
      moneyAddress: "",
      activeName: "",
      // navList: navList,
      headerclass: true,
      show: false,
      type: "",
      userName: "",
      isLogin: true,
      dialogType: "",
      dialogVisible: false,
      userMenu: false,
      usersStatus: "",
      currentPath: "/m/Intro",

      floag: false, //登录
      flogb: false, //注册
      flogc: false, //重置密码
      userEmail: "",
      userEmail1: "",
      url: "https://explorer.tfsc.io/tfscBrowser/user/",
      //url: "http://192.168.1.123:9200/tfscBrowser/user/",
      //  someKey: 0,
    };
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/m/Index") {
          // console.log(localStorage.getItem("email"));
          // console.log(to.query.userEmail);
          // console.log(this.userEmail);
          //this.userEmail = localStorage.getItem("email");
          if (localStorage.getItem("email") == null) {
            if (to.query.userEmail !== undefined) {
              this.userEmail = getSubStr(to.query.userEmail, 0, 4);
            }
            this.userEmail = null;
          } else {
            this.userEmail = getSubStr(localStorage.getItem("email"), 0, 4);
          }
          // console.log(this.userEmail);
          // this.userEmail = null;
          //console.log("点击是的发生的");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  // watch: {
  //   $route: {
  //     handler: function (to, form) {
  //       if (to.path === "/m/Index") {
  //         this.userEmail = to.query.userEmail;
  //         if(this.userEmail==undefined){
  //           this.userEmail = localStorage.getItem("email");
  //         this.userEmail = getSubStr(this.userEmail, 0, 4);
  //         }
  //         console.log(this.userEmail);
  //        // this.userEmail = null;
  //         console.log("点击是的发生的");
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll, true);
    this.type = this.$i18n.locale;
    if (
      this.userEmail !== "" ||
      this.userEmail !== null ||
      this.userEmail !== undefined
    ) {
      this.userEmail = localStorage.getItem("email");
      //  console.log(this.userEmail);
      this.userId = localStorage.getItem("userId");
      // console.log(this.userId);
      if (this.userEmail !== null) {
        this.userEmail = getSubStr(this.userEmail, 0, 5);
      }
      //  console.log(this.userEmail);
      // if (this.userEmail !== "") {
      //
      //   console.log(this.userEmail);
      // }
    }
  },
  created() {
    this.userName = localStorage.getItem("username");
    if (this.userName) {
      this.isLogin = false;
    }
    let _path = sessionStorage.getItem("currentPath");
    if (_path) {
      this.currentPath = "";
    }
    // this.checkUsersStatus();
  },
  // watch: {
  //   deep: true,
  //   userEmail(val) {
  //     console.log(val);
  //     // this.userEmail = val;
  //     this.userEmail = getSubStr(val, 0, 4);
  //   },
  // },
  methods: {
    // toggleVisibility() {
    //   this.floag = !this.floag;
    //   this.someKey += 1; // 修改不相关的数据
    // },
    showTestbox() {
      this.testflog = true;
      this.imglogo1 = require("@/assets/pc/Logo/shang.png");
    },
    hideTestbox() {
      this.testflog = false;
      this.imglogo1 = require("@/assets/pc/Logo/xia.png");
      // this.shows1 = false;
    },
    loginafter() {
      this.$router.push({
        path: "/m/Ownership",
        query: { userId: this.userId },
      });
    },
    //获取列表
    async getlist() {
      // if (
      //   this.userEmail == null ||
      //   this.userEmail == "" ||
      //   this.userEmail == undefined
      // ) {
      //   this.$message("Please log in again");
      //   this.$router.push("/pc/Index");
      //   return false;
      // }
      const params = {
        userId: this.userId,
        pageNum: 1,
        pageSize: 8,
        contractAddress: "",
      };

      //   console.log(params);
      let formData = new FormData();

      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "verifiedContractList";
      axios
        .post(url, formData, config)
        .then((res) => {
          if (res.data.code == 200) {
          } else if (res.data.code == 401) {
            //    console.log("进行了异地登录");
            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken");
            // this.userEmail = null;
            this.$message("Please log in again");
            this.$router.push({
              path: "/m/Index",
              query: { userEmail: "" },
            });
          }
          // if (res.data.result.code == 200) {
          //   this.lists = res.data.result.list;
          //   console.log(this.lists);

          // }
        })
        .catch((err) => {
          this.$message.error(err.message);
          console.log(err);
        });
    },
    back() {
      this.flogc = false;
      this.floag = true;
    },
    login() {
      //alert(1111);
      // window.location.reload();
      // console.log("点击登录");
      // console.log(this.userEmail);
      // if (this.userEmail== null) {
      //   this.floag = true;
      // }
      this.floag = true;
    },
    emails(val) {
      this.userEmail = val;
      // console.log(this.userEmail);
      // console.log("传过来的email值");
    },
    signups(val) {
      // console.log("接受注册传过来的值", val);
      this.flogb = val;
    },
    loginflog(val) {
      // console.log("接受login的值", val);
      this.floag = val;
    },
    repwd(val) {
      // console.log("接受重置repwd的值", val);
      this.flogc = val;
    },
    originNavClick() {
      this.userEmail = localStorage.getItem("email");

      // console.log(this.userEmail);
      // console.log("点击进入首页");
      this.$router.push("/m/Index");
      if (sessionStorage.getItem("currentPath")) {
        sessionStorage.removeItem("currentPath");
      }
      if (
        this.userEmail !== null ||
        this.userEmail !== "" ||
        this.userEmail !== undefined
      ) {
        this.userEmail = getSubStr(this.userEmail, 0, 4);
      }
      // console.log(this.userEmail);
      this.currentPath = "";
    },
    goPage(url) {
      sessionStorage.removeItem("tiaozhuan");
      sessionStorage.removeItem("tiaozhuan1");
      sessionStorage.removeItem("tiaozhuan2");
      sessionStorage.removeItem("tiaozhuan4");
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },
    buildPage() {
      /* const h = this.$createElement;
        this.$message({
          message: h('p', null, [
            h('span', null, 'In Building '),
            h('i', { style: 'color: teal' }, '...'),
          ]),
          type: 'warning',
        }); */
      this.$message({
        message: "In Building...",
        type: "warning",
      });
    },
    showUserMenu(item) {
      this.userMenu = true;
      this.show = false;
      this.showsubmenu = true;
    },
    showUserInfo(name) {
      this.isLogin = false;
      this.userName = name;
    },
    check() {
      this.dialogVisible = true;
      this.dialogType = "check";
      this.shows2 = true;
      this.shows1 = false;
    },
    close() {
      this.dialogVisible = false;
      this.dialogType = "";
      this.shows1 = false;
      this.shows2 = false;
      //  var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='';//出现滚动条
      //   document.removeEventListener("touchmove",mo,false);
    },
    handleClose(done) {
      this.$confirm(
        this.$t("index.switch") === "cn" ? " " : "Confirm shutdown?"
      )
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    changelang() {
      let type = "";
      if (this.type === "en") {
        type = "zh";
        this.language = "EN";
      }
      if (this.type === "zh") {
        type = "en";
        this.language = "中文";
      }
      this.show = false;
      sessionStorage.setItem("locale", type);
      this.type = sessionStorage.getItem("locale");
      this.$i18n.locale = sessionStorage.getItem("locale");
      // this.show = false;
    },

    showNav() {
      // const { show } = this;
      // this.show = !show;
      this.shows1 = true;
    },
    // back() {
    //   // if(!this.show) return
    //   this.userMenu = false;
    //   this.show = false;
    //   this.showsubmenu = false;
    // },
  },
};
</script>

<style lang="less">
/deep/.el-message {
  z-index: 9999999999;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;
  /* 其他样式调整，根据需要自行添加 */
}
@font-face {
  font-family: "Roboto";
  src: url("../../assets/font/Roboto-Medium.ttf");
  // src: url("../../assets/iconfont/PingFang-SC-Medium.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PingFang SC";
  // src: url("../../assets/iconfont/PingFang-SC-Medium.ttf");
  font-weight: normal;
  font-style: normal;
}
[class*="van-hairline"]::after {
  border-top: 1px solid #13161b;
  border-bottom: 1px solid #13161b;
}
.van-collapse-item__title--expanded .van-cell__title::after {
  color: #00a870;
}
.nav-header .navTag .van-cell__title::after {
  color: #00a870;
}
.van-collapse-item__title--expanded .van-cell__title::before {
  color: #00a870;
}
.van-collapse-item__content {
  //background: #232a35;
  // background: rgba(19, 22, 27, 0.8)
  //background-color: rgba(0,0,0,.7);
  // background: rgba(19, 22, 27, 0.8) !important;
  background: #13161b;
}
.van-collapse-item__title--expanded .van-cell__right-icon::before {
  color: #00a870;
}
.van-search .van-icon {
  margin: 0 !important;
}
.van-field__left-icon {
  margin-top: 18px !important;
  color: #fff;
  opacity: 0.55;
}
.van-collapse-item__wrapper {
  background: #232a35;
  // background-color: rgba(0,0,0,.7);
}
.van-field__left-icon .van-icon {
  font-size: 34px !important;
}
.van-search__content[data-v-65162d02] {
  background: #232a35 !important;
}
.van-collapse-item--border::after {
  //  border-top: 1px solid rgba(255, 255, 255, 0.15000000596046448) !important;
  border: none !important;
}
.van-cell::after {
  border: none !important;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.15000000596046448) !important;
}
.van-search .van-cell {
  border-radius: 0px 16px 16px 0px;
}
.nav-header .navTag i.van-icon {
  padding-right: 60px !important;
  // color: rgba(255, 255, 255, 0.55) !important;
}
.van-cell {
  background: rgba(19, 22, 27, 0.8) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-header .navTag .van-cell__title {
  padding-left: 0px !important;
  // opacity: 0.55 !important;
  font-size: 30px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
// .van-cell {
//   height: 120px;
//   //background: #ffffff;
//   background: #1C222B !important;
//   opacity: 0.95;
// }
.nav-header {
  width: 100vw;
  z-index: 999999999999999 !important;
  // height: 207px;
  // border: 1px solid red;

  .content {
    // border-bottom: 0.3vw solid rgba(255, 255, 255, 0.15000001);
    padding-right: 42px;
    height: 110px;
    display: flex;
    background: #13161b;
    justify-content: space-between;
    align-items: center;
    z-index: 99999999999 !important;

    .title1 {
      font-size: 30px;
      font-family: Poppins-Black, Poppins;
      font-weight: 800;
      color: #4573e7;
      line-height: 39px;
    }
    .subTitle {
      font-family: Poppins-Medium, Poppins;
    }
    //登录之后
    .loginafter {
      margin-top: 12px;
      display: flex;
      img {
        width: 58px;
        height: 58px;
        border-radius: 50%;
      }
      div {
        height: 28px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #00e79a;
        line-height: 28px;
        // margin-top: 10px;
        margin-left: 4px;
      }
    }
    //注册开始
    .signs {
      width: 141px;
      height: 68px;
      line-height: 68px;
      text-align: center;
      background: #000000;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;

      span {
        margin-left: 24px;
        font-size: 30px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #00e79a;
      }
    }
    div {
      display: flex;
      align-items: center;
    }
    .l {
      // width: 231.69px;
      height: 58.67px;
      opacity: 1;
      margin-right: 17px;
      margin-left: 50px;
      img {
        // width: 232px;
        height: 59px;
      }
      span {
        color: #ffffff;
        height: 46px;
        font-size: 32px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: 700;
        color: #ffffff;
        line-height: 46px;
        // font-size: 44px;
        // font-family: SF Pro Display-Semibold, SF Pro Display;
        // font-weight: 600;
        margin-left: 16px;
      }
    }
    .logo {
      width: 232px;
      height: 59px;
    }
    .l2 {
      width: 84px;
      height: 62px;
      margin-left: 15px;
    }
    .r {
      width: 70px;
      height: 70px;
    }
  }

  .navTag {
    z-index: 9999999999999 !important;
    width: 100vw;
    height: 100vh;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    overflow-y: scroll;
    display: inline-flex;
    flex-direction: column;
    background: #13161b;
    //连接测试网开始
    .Testnet {
      // border: 1px solid red;
      width: 234px;
      height: 80px;
      background: #252931;
      border-radius: 122px 122px 122px 122px;
      opacity: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      //  bottom: -670px;
      top:280px;
      left: 34px;

      // margin-top: 16px;
      .nettit {
        height: 35px;
        font-size: 30px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 35px;
        margin-top: 23px;
        margin-left: 32px;
      }
      .netselect {
        width: 54px;
        height: 36px;
        border-radius: 22px;
        background: #00e79a;
        margin-top: 22px;
        margin-left: 15px;
        img {
          width: 32px;
          height: 25px;
          margin-top: 7px;
          margin-left: 11px;
        }
      }
    }
    .testbox {
      width: 234px;
      height: 160px;
      background: #252931;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      position: absolute;
      top: -164px;
      // left: 24px;
      div {
        width: 234px;
        height: 80px;
        line-height: 80px;

        background: #252931;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        cursor: pointer;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #929396;
        cursor: pointer;
        span {
          margin-left: 12px;
        }
      }
      div:hover {
        width: 234px;
        height: 80px;
        line-height: 80px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        cursor: pointer;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
       // color: #00e79a;
        span {
          margin-left: 29px;
        }
      }
      // .Testnet{
      //   color: #fff;
      // }
      // .Testnet:hover{
      //   background: rgba(0, 0, 0, 0.8);
      //   color: #00e79a;
      // }
    }
    //连接测试网结束
    .Ecological {
      i {
        display: none !important;
      }
      .van-collapse-item__wrapper {
        display: none;
      }
    }
    .navtitle {
      // position:sticky;
      // top:0;
      z-index: 9;
      width: 100%;
      height: 107px;
      // border: 1px solid red;
      display: flex;
      // position: fixed;
      // transform: translateZ(0);
      // -webkit-transform: translateZ(0);
      // top: 0;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
      }
      .l {
        // width: 231.69px;
        height: 108.6px;
        opacity: 1;
        margin-right: 17px;
        margin-left: 50px;
        img {
          // width: 232px;
          height: 59px;
        }
        span {
          color: #ffffff;
          font-size: 44px;
          font-family: SF Pro Display-Semibold, SF Pro Display;
          font-weight: 600;
          margin-left: 16px;
        }
      }
      .title1 {
        font-family: Poppins-ExtraBold, Poppins;
        font-size: 30px;
        font-weight: 800;
        color: #4573e7;
        line-height: 110px;
        text-align: left;
      }
      .r {
        width: 70px;
        height: 70px;
        margin-right: 40px;
      }
    }
    van-cell {
      height: 120px;
      //background: #ffffff;
      background: rgba(0, 0, 0, 0.04) !important;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
    a {
      font-size: 28px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 33px;
    }
    .van-cell__title:hover {
      color: #00a870;
    }
    .van-cell__title {
      height: 120px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff !important;
      line-height: 120px;
      padding-left: 50px;
    }
    i.van-icon {
      padding-right: 50px;
      padding-top: 39px;
      color: #fff;
      width: 12px;
      height: 12px;
      opacity: 1;
    }
    .van-collapse-item__content {
      //  margin-left: 30px;
      // margin-right: 30px;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    .van-collapse-item-text:hover {
      color: #00a870;
    }
    .van-collapse-item-text {
      font-size: 28px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      // padding-top: 20px;
      padding-bottom: 20px;
      div {
        // padding-top: 20px;
        padding-left: 20px;
        a {
          display: block;
        }
      }
      .ahightlight {
        color: #fff;
      }
    }
    .highlight {
      color: #00a870;
      opacity: 1;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      // font-weight: normal;
      width: 702px;
      height: 80px;
      line-height: 80px;
      // line-height: 80px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      //border-radius: 10px;
    }
  }
  .bottom {
    flex: 1;
    width: 100%;
    // background: #fafafa;
    //background: rgba(0, 0, 0, 0.04);
    background: #202020;
    border-radius: 0px 0px 0px 0px;
  }
  .bot {
    width: 650px;
    height: 660px;
    left: 50px;
    position: relative;
    top: 20px;
    text-align: center;
    .dialog {
      margin: 0 auto;
      margin-bottom: 60px;
      img {
        width: 100px;
        height: 100px;
        opacity: 1;
      }
    }

    .community {
      margin-bottom: 40px;
      img {
        margin-right: 40px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.01);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
    }
    .bottom-copyright {
      margin: 0 20px 10px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
